import React, {ReactElement} from 'react';
import {toReadable} from 'shared/utils/number';

import {Text} from 'components/Text';
import {Control, Prefix, Row} from '../style';

type DailyAmountProps = {
  amount: MoneyAmount;
};

export const DailyAmount = ({amount}: DailyAmountProps): ReactElement => {
  return (
    amount > 0 && (
      <Row>
        <Prefix />
        <Control>
          <Text data-test='daily'>{toReadable(amount)} в день</Text>
        </Control>
      </Row>
    )
  );
};
